import {
    createBrowserRouter
} from "react-router-dom";

// PAGES
import Login from '../components/authentication/login'
import ForgotPassword from '../components/authentication/forgotPassword'
import CheckEmail from '../components/authentication/checkEmail';
import CodeVerification from '../components/authentication/codeVerification';
import ResetPassword from '../components/authentication/resetPassword';
import Error404Page from '../components/error/Error404Page'

// APP
import Dashboard from '../components/app/dashboard/dashboard';
import Facilities from '../components/app/facility_management/facilities'
import AccessPoints from '../components/app/access_points/access_points'
import AddNewFacility from '../components/app/facility_management/add_new_facility'

import Setting from '../components/app/settings/setting'

// FACILITY

import DashboardFacility from '../components/facility/dashboard/dashboard'
import UnitManagement from '../components/facility/unit_management/unit_management'
import ViewUnit from '../components/facility/unit_management/view_unit'
import ImportUnits from '../components/facility/unit_management/import_units'
import AddNewUnit from '../components/facility/unit_management/add_new_unit'

import VisitorAccessManagementHome from '../components/facility/visitor_access_management/home/home'
import VisitorRegistration from "../components/facility/visitor_access_management/visitor_registration/gate_registration";
import WaitingList from "../components/facility/visitor_access_management/wait_list/waiting_list";
import VisitorList from "../components/facility/visitor_access_management/visitor_registration/visitor_list";
import VisitorRequests from "../components/facility/visitor_access_management/visitor_registration/visitor_requests";
import GuardRegistration from "../components/facility/visitor_access_management/guard_registration/guard_registration";
import RegisterGuard from "../components/facility/visitor_access_management/guard_registration/register_guard";
import GuardManagement from "../components/facility/visitor_access_management/guard_registration/guard_management";
import EntriesAndExits from "../components/facility/visitor_access_management/entries_and_exits/entries_and_exits";
import Faq from "../components/facility/visitor_access_management/faq/faq";
import AddFaq from "../components/facility/visitor_access_management/faq/add_faq";
import EditFaq from "../components/facility/visitor_access_management/faq/edit_faq";
import AddEntryAndExit from "../components/facility/visitor_access_management/entries_and_exits/add_entry_and_exit";
import ViewDigitalLog from '../components/facility/visitor_access_management/digital_logs/get_digital_log'
import DigitalLogs from "../components/facility/visitor_access_management/digital_logs/digital_logs";
import AccessControl from "../components/facility/visitor_access_management/access_control/access_control";
import ScanQRCode from '../components/facility/visitor_access_management/qrcode/scan_qr_code'
import CustomerManagement from "../components/facility/customer_management/customer_management";
import AddNewCustomer from "../components/facility/customer_management/add_new_customer";
import ViewCustomer from "../components/facility/customer_management/view_customer";

import Settings from '../components/facility/settings/settings'
import VerifyCode from "../components/facility/visitor_access_management/verifycode/verify_code";
import ViewWaitingList from "../components/facility/visitor_access_management/wait_list/view_waiting_list";
import Deliveries from "../components/facility/visitor_access_management/visitor_registration/deliveries";
import PrivacyPolicy from "../components/facility/visitor_access_management/privacy_policy/privacy_policy";
import BlockedPlates from "../components/facility/visitor_access_management/blocked_cars/blocked_plates";
import SearchPlates from "../components/facility/visitor_access_management/search_plates/search_plate";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />,
    },

    {
        path: "/forgot_password",
        element: <ForgotPassword />,
    },
    {
        path: "/check_email",
        element: <CheckEmail />,
    },
    {
        path: "/code_verification",
        element: <CodeVerification />,
    },
    {
        path: "/reset_password/:userId",
        element: <ResetPassword />,
    },
    {
        path: "/app/",
        element: <Dashboard />,
    },
    {
        path: "/app/facilities",
        element: <Facilities />,
    },
    {
        path: "/app/access_points",
        element: <AccessPoints />,
    },
    {
        path: "/app/add_new_facility",
        element: <AddNewFacility />,
    },
    {
        path: "/app/facility-details",
        element: <Dashboard />,
    },

    {
        path: "/app/settings",
        element: <Setting />,
    },
    {
        path: "/facility/",
        element: <DashboardFacility />
    },

    {
        path: "/facility/unit_management",
        element: <UnitManagement />
    },
    {
        path: "/facility/settings",
        element: <Settings />,
    },
    {
        path: "/facility/unit_management/view_unit/:unitId",
        element: <ViewUnit />
    },
    {
        path: "/facility/unit_management/add_new_unit",
        element: <AddNewUnit />
    },
    {
        path: "/facility/unit_management/import_units",
        element: <ImportUnits />
    },
    {
        path: "/facility/customer_management",
        element: <CustomerManagement />
    },
    {
        path: "/facility/customer_management/add_new_customer",
        element: <AddNewCustomer />
    },
    {
        path: "/facility/customer_management/view_customer/:customerId",
        element: <ViewCustomer />
    },
    {
        path: "/facility/visitor_access_management/home",
        element: <VisitorAccessManagementHome />,
    },
    {
        path: "/facility/visitor_access_management/visitor_registration/gate_registration",
        element: <VisitorRegistration />
    },
    {
        path: "/facility/visitor_access_management/visitor_registration/deliveries",
        element: <Deliveries />
    },
    {
        path: "/facility/visitor_access_management/qrcode/scan_qr_code",
        element: <ScanQRCode />
    }, {
        path: "/facility/visitor_access_management/code/verify",
        element: <VerifyCode />
    },
    {
        path: "/facility/visitor_access_management/visitor_registration/visitor_list",
        element: <VisitorList />
    },
    {
        path: "/facility/visitor_access_management/visitor_registration/visitor_requests",
        element: <VisitorRequests />
    },
    {
        path: "/facility/visitor_access_management/guard_registration/guard_registration",
        element: <GuardRegistration />
    },
    {
        path: "/facility/visitor_access_management/guard_registration/register_guard",
        element: <RegisterGuard />
    },
    {
        path: "/facility/visitor_access_management/waiting_list",
        element: <WaitingList />
    },
    {
        path: "/facility/visitor_access_management/view_waiting_list/:visitLogId",
        element: <ViewWaitingList />
    },
    {
        path: "/facility/visitor_access_management/guard_registration",
        element: <GuardManagement />
    },
    {
        path: "/facility/visitor_access_management/digital_logs/",
        element: <DigitalLogs />
    },
    {
        path: "/facility/visitor_access_management/view_digital_log/:visitLogId",
        element: <ViewDigitalLog />
    },
    {
        path: "/facility/visitor_access_management/entries_and_exits",
        element: <EntriesAndExits />
    },
    {
        path: "/faq",
        element: <Faq />
    },
    {
        path: "/facility/visitor_access_management/faq/add_faq",
        element: <AddFaq />
    },
    {
        path: "/facility/visitor_access_management/faq/edit_faq/:faqId",
        element: <EditFaq />
    },
    {
        path: "/facility/visitor_access_management/entries_and_exits/add_entry_and_exit",
        element: <AddEntryAndExit />
    },

    {
        path: "/facilitiy/visitor_management/access_control",
        element: <AccessControl />
    },
    {
        path: "/privacy_policy",
        element: <PrivacyPolicy />
    },
    {
        path: "/facility/blocked_plates",
        element: <BlockedPlates />
    },
    {
        path: "/facility/search_plates",
        element: <SearchPlates />
    },

    {
        path: "*",
        element: <Error404Page />,
    },
]);
